import {get} from 'lodash'

export const getTags = state => state.settingsContext.tags || []

export const getShowDormants = state => state.settingsContext.teams.showDormants

export const getInternalUsers = state => state.settingsContext.contacts

export const getExternalUsers = state => state.settingsContext.externalContacts

export const getRoles = state => Object.values(state.settingsContext.roles)

export const getLicences = state => state.settingsContext.licences

export const getPackages = state => state.settingsContext.packages

export const getPermissions = state => state.settingsContext.permissions || []

export const getTrustedDevices = state => state.settingsContext.trustedDevice.pivotTable.data.data || []

export const getAllUsers = (state) => {
  const internalUsers = Object.values(state.settingsContext.contacts)
  const externalUsers = Object.values(state.settingsContext.externalContacts)
  return [...internalUsers, ...externalUsers]
}

export const isUpdatingLogins = state => state.settingsContext.isUpdatingLogins

export const isLoadingTfaCode = state => state.settingsContext.tFASettings.isLoadingTfaCode

export const getDocumentFolderTemplates = state => get(state, 'settingsContext.documentFolderTemplates', [])

export const getTfaQRCode = state => state.settingsContext.tFASettings.tfaQRCode

export const getTfaQRCodeError = state => state.settingsContext.tFASettings.tfaQRCodeError

export const isEnablingTfa = state => state.settingsContext.tFASettings.isEnablingTfa

export const isEnableTfaError = state => state.settingsContext.tFASettings.isEnableTfaError

export const isShowTfaSetup = state => get(state, 'settingsContext.tFASettings.isShowTfaSetup', false)

export const isIncludeTfaIntroDialog = state =>
  get(state, 'settingsContext.tFASettings.isIncludeTfaIntroDialog', true)

export const isTotpAuthenticateError = state =>
  get(state, 'settingsContext.tFASettings.isTotpAuthenticateError', false)

export const isShowTfaLoginForm = state => get(state, 'settingsContext.tFASettings.isShowTfaLoginForm', false)

export const getSupportTokens = state => get(state, 'settingsContext.supportTokens', [])

export const isLoadingSupportTokens = state => get(state, 'settingsContext.loadingSupportTokens', false)